import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChatService } from '../../service/chat-service';


interface ResponseType {
  error?: string;
}
@Component({
    selector: 'app-abiochat-reference-dialog',
    templateUrl: './abiochat-reference-dialog.component.html',
    styleUrl: './abiochat-reference-dialog.component.scss',
    standalone: false
})
export class AbiochatReferenceDialogComponent {
  public selectedTabIndex: number = 0;
  roleName: string;
  chunkContent: any;
  pageNo: (string | number)[] = [];
  durations: (any)[] = [];
  documents: any;
  dispDocuments: any;
  matchingIndices: Array<{ index: number, pageNumber: number, isMatch: boolean }>;
  chatValues: any;
  selectedPageIndex = 0;
  selectedSubTabIndex = 0;
  responseOverlapData: any = null;
  docName: string;
  currentScore: number;
  currentChunkText: string;
  currentDocName: string;
  currentPageNo: number;
  isMaximized: boolean;
  constructor(
    public dialogRef: MatDialogRef<AbiochatReferenceDialogComponent>, public ChatService: ChatService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(MAT_DIALOG_DATA) public title: any
  ) {
    this.chatValues = data.chatValues
    this.pageNo = data.page_numbers;
    this.durations = data.durations;
    this.docName = data.fileName;
    this.documents = this.data.chatValues.documents;
    this.dispDocuments = this.data.chatValues.disDocument;
    this.roleName = sessionStorage.getItem("role");
    this.extractValues();
  }
  isLoading = true; // Initially show the loader
  updateContent(newData: any, title: string) {
    this.data = newData;
    this.title = title;
    this.isLoading = false;
  }
  onPageTabChange(localIndex: number): void {
    const matchedObj = this.matchingIndices[localIndex];
    const documentIndex = matchedObj.index;
    this.getStaticInfo(documentIndex)
    this.updateResponseData(documentIndex)
  }
  getStaticInfo(index: number) {
    this.selectedPageIndex = index;
    const selectedData = this.chatValues.chunkContent?.[index];
    if (selectedData) {
      this.currentScore = selectedData.score;
      this.currentPageNo = selectedData.page_no;
      this.currentChunkText = selectedData.chunk_text;
    }
  }
  extractValues() {
    const docName = this.docName;
    this.matchingIndices = this.documents.map((doc, idx) => {
        const pageNumber = doc.page_numbers ?? doc.page_number ?? doc.page_no;
        const docNameField = doc.doc_name ?? doc.file_name;
        const start_time = doc.start_time ? doc.start_time : null;
        let  isMatch: boolean;
        if(this.pageNo)
          isMatch = (docNameField === docName) && this.pageNo.some(n => String(n) === String(pageNumber));
        else
          isMatch = (docNameField === docName) && this.durations.some(dur => dur.start === start_time);
        return {
          index: idx,
          pageNumber: pageNumber,
          isMatch: isMatch
        };
      }).filter(item => item.isMatch);
    if (this.matchingIndices.length === 0) return;
    this.getStaticInfo(this.matchingIndices[0].index)
    this.updateResponseData(this.matchingIndices[0].index)
  }
  toggleMaximize() {
    this.isMaximized = !this.isMaximized;
     const dialogContainer = document.querySelector('.mat-mdc-dialog-container');
    if (dialogContainer) {
      if (this.isMaximized) {
        dialogContainer.classList.add('maximized');
      } else {
        dialogContainer.classList.remove('maximized');
      }
    }
  }
  updateResponseData(index: number): void {
    this.resetContent();
    let requestData = {
      chunk_id: [String(this.chatValues.chunkContent[index].chunk_id)],
      chunk_content: this.chatValues.chunkContent[index].chunk_text,
      llm_response: this.chatValues.response,
      business_unit_code: sessionStorage.getItem('businessUnitCode'),
      user_request: this.chatValues.userRequest,
      created_by: Number(sessionStorage.getItem('userId'))
    }
    this.ChatService.postRefernceData(requestData, this.data.chatStatus).subscribe((response: ResponseType) => {
      this.isLoading = false;
      if (response?.[0]?.hasOwnProperty("error_code")) {
        //let responseArr: any = response?.error.split("|===|===|");
        let responseArr: any = response;
        this.updateContent( responseArr[0].friendly_message, 'Response Overlap');
      } else {
        this.updateContent(response, 'Response Overlap');
      }
      
    });
  }
  resetContent(){
    this.data = '';
    this.title = '';
    this.isLoading = true;
  }
}
